export default function Features() {
  const features = [
    {
      icon: 'ri-shield-check-line',
      title: 'Advanced Security',
      description: 'Military-grade AES-256 encryption ensures your data remains completely secure and protected from any threats or unauthorized access attempts.',
      gradient: 'from-cyan-400 to-cyan-600'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Ultra-Fast Speed',
      description: 'Experience blazing-fast connection speeds with our optimized server infrastructure, perfect for streaming, gaming, and downloading without any lag.',
      gradient: 'from-purple-400 to-purple-600'
    },
    {
      icon: 'ri-earth-line',
      title: 'Global Coverage',
      description: 'Access our extensive network of high-performance servers located in multiple countries worldwide, giving you true internet freedom wherever you are.',
      gradient: 'from-cyan-500 to-purple-500'
    },
    {
      icon: 'ri-lock-line',
      title: 'Zero Logs Policy',
      description: 'We never track, collect, or store your online activities. Your browsing history and personal data remain completely private and anonymous at all times.',
      gradient: 'from-purple-500 to-pink-500'
    },
    {
      icon: 'ri-device-line',
      title: 'Multi-Device Support',
      description: 'Protect all your devices simultaneously with one account. Compatible with Windows, Mac, iOS, Android, and more for seamless cross-platform security.',
      gradient: 'from-cyan-400 to-blue-500'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Our dedicated support team is always available to assist you with any questions or technical issues, ensuring you have the best VPN experience possible.',
      gradient: 'from-purple-400 to-cyan-400'
    }
  ];

  return (
    <section id="features" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <h2 className="text-5xl font-bold text-gray-900 mb-4">Why Choose ECJL VPN</h2>
          <p className="text-xl text-gray-600 max-w-2xl">
            Discover the powerful features that make ECJL VPN the perfect choice for your online security and privacy needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-10 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              <div className={`w-20 h-20 bg-gradient-to-br ${feature.gradient} rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${feature.icon} text-3xl text-white`}></i>
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-4">{feature.title}</h3>
              <p className="text-base text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
